module.exports = __webpack_public_path__ + "img/desk1.36cfd5cd.png";